
  import { defineComponent } from 'vue';
  import { GrouperLayoutMode } from 'src/services/IodineGrouperService';
  import { useLayoutStore } from 'stores/layout-store';
  import { useGrouperStore } from 'stores/grouper-store';
  import debounce from 'lodash.debounce';

  export default defineComponent({
    name: 'App',
      computed: {
          consolidated: () => {
              return useLayoutStore().layoutMode != GrouperLayoutMode.fullScreen;
          },
          embeddedResourcesOpen: () => {
            return useLayoutStore().isResourcesOpen
          }
      },
      unmounted() {
          useGrouperStore().$reset();
      },
      mounted() {
          useGrouperStore().$onMount();
      }
  });

  // eslint-disable-next-line
  const _ = (window as any).ResizeObserver;
  // eslint-disable-next-line
  (window as any). ResizeObserver = class ResizeObserver extends _ {
      constructor(callback: (...args: unknown[]) => void) {
          callback = debounce(callback, 20);
          super(callback);
      }
  };
